export const stocksReducer = (state = {loading: true, result: null, stocks: [], stocksWithCandidates: []} , action) => {
    switch (action.type) {
        case 'STOCK_GET_ALL_SUCCESS':
            return {
                ...state,
                loading: false,
                stocks: action.payload
            }
        case 'STOCK_GET_WITH_ALL_SUCCESS':
            return {
                ...state,
                loading: false,
                stocksWithCandidates: action.payload
            }
        case 'STOCK_EDIT_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                stocks: state.stocks.some(stock => stock._id === action.payload.stock._id)
                    ? state.stocks.map(stock =>
                        stock._id === action.payload.stock._id ? action.payload.stock : stock
                    )
                    : [...state.stocks, action.payload.stock]
            }
        case 'STOCK_EDIT_BY_MULTISCHOOL_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message
            }
        case 'STOCK_EDIT_WITH_ALL_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                stocksWithCandidates: state.stocksWithCandidates.map(stock => stock?.candidate?._id === action.payload.stock.candidate ? {...stock, typeStock: action.payload.stock.type} : stock)
            }
        case 'STOCK_DELETE_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                stocks: state.stocks.filter(stock => stock._id !== action.payload.stockId)
            }
        case 'STOCK_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'STOCK_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'STOCK_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

